var _path, _path2, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.35,57.57H11.65v-50a.1.1,0,0,1,.16-.08l4.11,3.85a.12.12,0,0,0,.13,0l3.3-3.89a.09.09,0,0,1,.12,0l3.72,3.9a.11.11,0,0,0,.13,0l3.29-3.89a.09.09,0,0,1,.13,0l2.86,3.87a.11.11,0,0,0,.14,0L33,7.46a.09.09,0,0,1,.13,0l2.69,3.86a.1.1,0,0,0,.14,0l2.88-3.86a.1.1,0,0,1,.14,0l2.85,3.86a.1.1,0,0,0,.14,0L44.7,7.48a.09.09,0,0,1,.15,0l2.25,3.84a.11.11,0,0,0,.13,0l5-3.87a.1.1,0,0,1,.15.09Z",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.09,19.31,34.8,24.8a.08.08,0,0,0,.07.05l6.06.88a.1.1,0,0,1,0,.17L36.6,30.17a.16.16,0,0,0,0,.09l1,6a.11.11,0,0,1-.15.11l-5.41-2.85a.09.09,0,0,0-.1,0L26.54,36.4a.11.11,0,0,1-.15-.11l1-6a.16.16,0,0,0,0-.09L23,25.9a.1.1,0,0,1,.05-.17l6.06-.88a.08.08,0,0,0,.07-.05l2.71-5.49A.1.1,0,0,1,32.09,19.31Z",
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.42,
    y1: 43.54,
    x2: 46.02,
    y2: 43.54,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19.42,
    y1: 49.78,
    x2: 46.02,
    y2: 49.78,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.5761401c6f987f56b70aac1ff3787d46.svg";
export { ForwardRef as ReactComponent };